import React, { memo } from 'react'

import { fancyTimeFormat } from '../helpers/fancyTimeFormat'

import { getPbgidIcon, getPbgidName, usePbgidIcons } from '../helpers/pbgidIcons'
import { DEFAULT_LANG } from '../helpers/i18n'

/** Local icon from the pbgid first, the summary icon is only a fallback */
function resolveIcon(landmark, pbgidIcons) {
	return getPbgidIcon(pbgidIcons, parseInt(landmark.pbgid)) ?? landmark.icon ?? '/liveGameIcons/unknown.png'
}

// Some names carry extra info, e.g. "House of Wisdom (Culture Wing)" -> "House of Wisdom"
function cleanName(name) {
	return String(name ?? '')
		.replace(/\s*\([^)]*\)/g, '')
		.trim()
}

// side: 'left' keeps the icon on the icon-first side, 'right' mirrors the row so the icon sits on the outer edge
const LandmarkDisplay = memo(({ landmarks, side = 'left', className = '', lang = DEFAULT_LANG }) => {
	const pbgidIcons = usePbgidIcons()

	// Only the landmarks/wings that aged the player up, oldest first
	const ageUps = (landmarks ?? [])
		.filter((landmark) => !!landmark?.newAge)
		.slice()
		.sort((a, b) => a.gameTime - b.gameTime)

	if (!ageUps.length) return null

	return (
		<div className={`landmarks landmarks--${side} ${className}`.trim()}>
			{ageUps.map((landmark, index) => (
				<div key={`${landmark.pbgid}-${landmark.gameTime}-${index}`} className={`landmarks__item landmarks__item--age${landmark.newAge}`}>
					<div className="landmarks__iconBox" style={{ backgroundImage: `url(/liveGameIcons/empty_background.png)` }}>
						<img className="landmarks__icon" src={resolveIcon(landmark, pbgidIcons)} alt="" />
					</div>
					<div className="landmarks__name">{cleanName(landmark.name || getPbgidName(pbgidIcons, parseInt(landmark.pbgid), lang))}</div>
					<div className="landmarks__time">{fancyTimeFormat(landmark.gameTime)}</div>
				</div>
			))}
		</div>
	)
})

export { LandmarkDisplay }
